import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="work-status"
export default class extends Controller {
  static targets = [];
  static values = {
    status: String
  };

  connect() {
    console.log("workStatusController connected");
  }

  async updateStatus(event) {
    const workIds = Array.from(
      this.element.querySelectorAll("[name*=work_ids]:checked")
    ).map((el) => el.value);
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    const status = event.target.dataset.status;

    const response = await fetch("/works/bulk_update_status", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ work_ids: workIds, status: status })
    });

    if (response.ok) {
      workIds.forEach((id) => {
        const row = document.querySelector(`tr[data-work-id="${id}"]`);
        if (row) {
          row.classList.remove(
            "table-secondary",
            "table-danger",
            "table-warning"
          );
          if (["めっき完了", "検査完了"].includes(status)) {
            row.classList.add("table-secondary");
          } else if (["社内不良", "社外不良"].includes(status)) {
            row.classList.add("table-danger");
          }
          row.querySelector("[name=status]").textContent = status;
          if (status === "検査完了") {
            row.classList.add("check-completed");
            row.style.display = "none";
          }
        }
      });
      Array.from(
        this.element.querySelectorAll("[name*=work_ids]:checked")
      ).forEach((el) => (el.checked = false));
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `成功しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }

  showCheckCompletedRow() {
    const checkCompletedRows = document.querySelectorAll(".check-completed");
    checkCompletedRows.forEach((row) => {
      row.style.display = row.style.display === "none" ? "" : "none";
    });
  }

  async createEnergizeRecord() {
    const workIds = Array.from(
      this.element.querySelectorAll("[name*=work_ids]:checked")
    ).map((el) => el.value);

    if (workIds.length === 0) {
      alert("作業を選択してください。");
      return;
    }
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch("/works/create_energize_record", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ work_ids: workIds })
    });

    if (response.ok) {
      const data = await response.json();
      window.location.href = `/energize_records/${data.energize_record_id}/edit`;
    }
  }

  async createRedoWorks() {
    const redoAt = document.getElementById("redo_at").value;
    if (!redoAt) {
      alert("複写先の開始日時を入力してください。");
      return;
    }

    const workIds = Array.from(
      this.element.querySelectorAll("[name*=work_ids]:checked")
    ).map((el) => el.value);

    if (workIds.length === 0) {
      alert("複写する作業を選択してください。");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    if (!confirm("選択した作業を複写して移動しますか？")) return;

    const response = await fetch("/works/create_redo_works", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ work_ids: workIds, started_at: redoAt })
    });

    if (response.ok) {
      window.location.reload();
    }
  }

  async updateWorksStartedAt() {
    const startedAt = document.getElementById("started_at").value;
    if (!startedAt) {
      alert("開始日時を入力してください。");
      return;
    }

    const workIds = Array.from(
      this.element.querySelectorAll("[name*=work_ids]:checked")
    ).map((el) => el.value);

    if (workIds.length === 0) {
      alert("作業を選択してください。");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    if (!confirm("選択した作業の開始日時を移動しますか？")) return;

    for (const id of workIds) {
      await fetch(`/works/${id}`, {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ work: { started_at: startedAt } })
      });
    }

    window.location.reload();
  }

  async updateWorkWorkQuantity(event) {
    const id = event.target.closest("tr").dataset.workId;
    const workQuantity = event.target.value;
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/works/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ work: { work_quantity: workQuantity } })
    });

    if (response.ok) {
      const alert = document.createElement("div");
      alert.className = "alert alert-success alert-position text-center";
      alert.innerHTML = `作業数量を更新しました。`;
      document.body.appendChild(alert);
      setTimeout(() => alert.remove(), 2000);
    }
  }
}
